<template>
  <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect">
     <slot>RippleButton</slot>
  </button>
</template>

<script>
export default {
  name: 'ripple-button'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RippleButton.vue